export const mailActions = {
    REFRESH: 'REFRESH',
    REPLAY: 'REPLAY',
    REPLAY_ALL: 'REPLAY_ALL',
    SHARE: 'SHARE',
    EDIT: 'EDIT',
    MAKE_READ: "MAKE_READ",
    MAKE_UNREAD: "MAKE_UNREAD",
    MAKE_IMPORTANT: "MAKE_IMPORTANT",
    MAKE_NOT_IMPORTANT: "MAKE_NOT_IMPORTANT",
    CHANGE_FOLDER: "CHANGE_FOLDER",
    PRINT: "PRINT",
    DELETE: "DELETE",
    TAG_PROJECT: "TAG_PROJECT",

}
